module.exports = __webpack_public_path__ + "static/media/wallet.d508faa9.svg";